import { useCallback, useEffect, useRef, useState } from "react";

/** Espera das buscas do Configuration Server e do Reference Data (spec 2026-10-29, melhoria 5). */
export const SEARCH_DEBOUNCE_MS = 3000;

/**
 * O valor aplicado só muda `delay` ms depois da última mudança: a busca não dispara uma
 * consulta (ou um filtro) por tecla. `commitNow`, ligado ao Enter da caixa, aplica o valor
 * atual na hora e cancela a espera. A caixa continua mostrando o que a pessoa digitou.
 */
export function useDebouncedSearch<T>(value: T, delay = SEARCH_DEBOUNCE_MS): [T, () => void] {
  const [debounced, setDebounced] = useState(value);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    timer.current = setTimeout(() => setDebounced(value), delay);
    return () => {
      if (timer.current !== null) clearTimeout(timer.current);
      timer.current = null;
    };
  }, [value, delay]);
  const commitNow = useCallback(() => {
    if (timer.current !== null) clearTimeout(timer.current);
    timer.current = null;
    setDebounced(value);
  }, [value]);
  return [debounced, commitNow];
}
